var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { registerSystem, DEPTHS } from "./components/ComponentRegistry.js";
import "./components/types.js";
import { Component, Schema, type, defaultValue } from "./decorators/type.js";
import { C as ComponentCategory } from "./enums-86f58524.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let FadeOnTimeoutSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "startFrame");
    __publicField(this, "timeout");
    __publicField(this, "fadeMs");
    __publicField(this, "dieOnTimeout");
  }
};
__decorateClass([
  type("number"),
  defaultValue(0)
], FadeOnTimeoutSchema.prototype, "startFrame", 2);
__decorateClass([
  type("number"),
  defaultValue(1e3)
], FadeOnTimeoutSchema.prototype, "timeout", 2);
__decorateClass([
  type("number"),
  defaultValue(1e3)
], FadeOnTimeoutSchema.prototype, "fadeMs", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], FadeOnTimeoutSchema.prototype, "dieOnTimeout", 2);
FadeOnTimeoutSchema = __decorateClass([
  Component("FadeOnTimeout")
], FadeOnTimeoutSchema);
class FadeOnTimeoutSystem {
  constructor() {
    __publicField(this, "type", "FadeOnTimeout");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", FadeOnTimeoutSchema);
    __publicField(this, "depth", DEPTHS.HEALTH + 1);
  }
  run(entity, gameModel) {
    const data = gameModel.getTypedUnsafe(entity, FadeOnTimeoutSchema);
    if (data.startFrame === 0) {
      data.startFrame = data.timeout + data.fadeMs;
    } else {
      data.startFrame -= gameModel.frameDt;
    }
    if (data.startFrame <= data.fadeMs) {
      if (data.startFrame > 0) {
        const renderingComponents = gameModel.getComponentIdsByCategory(entity, ComponentCategory.RENDERING);
        for (let i = 0; i < renderingComponents.length; i++) {
          const componentData = gameModel.getComponent(entity, renderingComponents[i]);
          if (componentData.opacity !== void 0) {
            componentData.opacity = data.startFrame / data.fadeMs;
          }
        }
      } else {
        if (data.dieOnTimeout) {
          gameModel.getComponentUnsafe(entity, "Health").health = 0;
        } else {
          gameModel.removeEntity(entity);
        }
      }
    }
  }
}
registerSystem(FadeOnTimeoutSystem);
const __vite_glob_0_34 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get FadeOnTimeoutSchema() {
    return FadeOnTimeoutSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  FadeOnTimeoutSchema as F,
  __vite_glob_0_34 as _
};
//# sourceMappingURL=FadeOnTimeoutComponent-a83db7ee.js.map
